"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var classnames_1 = __importDefault(require("classnames"));
var React = __importStar(require("react"));
var Icon_1 = require("../Icon");
var chevron_down_icon_svg_1 = __importDefault(require("../../icons/chevron-down.icon.svg"));
var ellipsis_icon_svg_1 = __importDefault(require("../../icons/ellipsis.icon.svg"));
var DropdownMenu_1 = __importDefault(require("./DropdownMenu"));
var Dropdown_module_scss_1 = __importDefault(require("./Dropdown.module.scss"));
/**
 * @deprecated Dropdown is deprecated. Please use draft-menu instead.
 */
var Dropdown = /** @class */ (function (_super) {
    __extends(Dropdown, _super);
    function Dropdown(props) {
        var _this = _super.call(this, props) || this;
        _this.dropdownButton = React.createRef();
        _this.toggleDropdownMenu = function (e) {
            e.stopPropagation();
            var currentState = _this.state.isMenuVisible;
            _this.setState({
                isMenuVisible: !currentState
            });
        };
        _this.hideDropdownMenu = function () {
            _this.setState({
                isMenuVisible: false
            });
        };
        _this.renderIcon = function (icon) {
            if (!icon)
                return;
            return (React.createElement("span", { className: Dropdown_module_scss_1["default"].dropdownIcon },
                React.createElement(Icon_1.Icon, { icon: icon, role: "img", title: "Open menu" })));
        };
        _this.renderDownArrow = function () {
            var _a = _this.props, label = _a.label, controlAction = _a.controlAction;
            if (!label || !controlAction)
                return;
            return (React.createElement("span", { className: Dropdown_module_scss_1["default"].chevronIcon },
                React.createElement(Icon_1.Icon, { icon: chevron_down_icon_svg_1["default"], role: "img", title: "Open menu" })));
        };
        _this.renderButtonContent = function () {
            var label = _this.props.label;
            var icon = _this.props.icon;
            if (!icon && !label) {
                icon = ellipsis_icon_svg_1["default"];
            }
            return (React.createElement(React.Fragment, null,
                _this.renderIcon(icon),
                label && React.createElement("span", { className: Dropdown_module_scss_1["default"].dropdownLabel }, label),
                _this.renderDownArrow()));
        };
        _this.renderReversedButtonContent = function () {
            var _a = _this.props, icon = _a.icon, label = _a.label;
            return (React.createElement(React.Fragment, null,
                _this.renderDownArrow(),
                label && React.createElement("span", { className: Dropdown_module_scss_1["default"].dropdownLabel }, label),
                _this.renderIcon(icon)));
        };
        _this.state = {
            isMenuVisible: Boolean(props.menuVisible)
        };
        return _this;
    }
    Dropdown.prototype.getPosition = function () {
        return this.dropdownButton && this.dropdownButton.current
            ? this.dropdownButton.current.getBoundingClientRect()
            : null;
    };
    Dropdown.prototype.renderDropdownMenu = function () {
        return (React.createElement(DropdownMenu_1["default"], { hideDropdownMenu: this.hideDropdownMenu, position: this.getPosition() }, this.props.children));
    };
    Dropdown.prototype.render = function () {
        var _a;
        var _b = this.props, controlAction = _b.controlAction, automationId = _b.automationId, iconPosition = _b.iconPosition, reversedColor = _b.reversedColor;
        var reverseIcon = iconPosition === "end";
        var btnClass = (0, classnames_1["default"])(Dropdown_module_scss_1["default"].dropdownButton, (_a = {},
            _a[Dropdown_module_scss_1["default"].dropdownControlAction] = controlAction,
            _a[Dropdown_module_scss_1["default"].isOpen] = this.state.isMenuVisible,
            _a[Dropdown_module_scss_1["default"].reversedColor] = reversedColor,
            _a));
        return (React.createElement("div", { className: Dropdown_module_scss_1["default"].dropdown },
            React.createElement("button", { className: btnClass, onClick: this.toggleDropdownMenu, onMouseDown: function (e) { return e.preventDefault(); }, ref: this.dropdownButton, "data-automation-id": automationId },
                !reverseIcon && this.renderButtonContent(),
                reverseIcon && this.renderReversedButtonContent()),
            this.state.isMenuVisible && this.renderDropdownMenu()));
    };
    Dropdown.displayName = "Dropdown";
    Dropdown.defaultProps = {
        iconPosition: "start"
    };
    return Dropdown;
}(React.Component));
exports["default"] = Dropdown;
//# sourceMappingURL=Dropdown.js.map